export default "/_next/static/images/2154c43e33a1ab4c7b6098c7fb30c633.png";